import $router from '@/router/index'

import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'
import ECB from 'crypto-js/mode-ecb'
import Pkcs7 from 'crypto-js/pad-pkcs7'

// let key = Utf8.parse("1234567");
const key = 'ISP'
const num = 2
/* 加密 */
export function AESencrypt (word) {
  // 加密
  const srcs = Utf8.parse(word)
  const encrypted = AES.encrypt(srcs, key, {
    mode: ECB,
    padding: Pkcs7
  }) // 加密模式为ECB，补码方式为PKCS5Padding（也就是PKCS7）

  return encrypted.toString()
  // let str = "";
  // // console.log(txtVal);
  // for (let i = 0; i < txtVal.length; i++) {
  //     str += String.fromCharCode(txtVal.charCodeAt(i) - num);
  // }
  // return str
}

/* 解密 */
export function AESdecrypt (word) {
  // 解密
  const decrypted = AES.decrypt(word, key, {
    mode: ECB,
    padding: Pkcs7
  })
  return Utf8.stringify(decrypted).toString()
  // let str = "";
  // // console.log(txtVal);
  // for (let i = 0; i < txtVal.length; i++) {
  //     str += String.fromCharCode(txtVal.charCodeAt(i) + num);
  // }
  // return str
}
// export function randomCoding() {

//     //生成一个0到25的数字
//     var ranNum = Math.ceil(Math.random() * 25);
//     //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;
//     //然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
//     return String.fromCharCode(65 + ranNum)

// }

export function AESOBJencrypt (obj) {
  if (!obj) return ''
  let objStr = ''
  try {
    objStr = JSON.stringify(obj)
  } catch (error) {

  }
  return AESencrypt(objStr)
}

export function AESOBJdecrypt (aesStr) {
  if (!aesStr) return ''
  const objStr = AESdecrypt(aesStr)
  let obj = null
  try {
    obj = JSON.parse(objStr)
  } catch (error) {

  }
  return obj
}

export function random (min = 1, max = 99) {
  return Math.floor(Math.random() * (max - min)) + min
}
export function encrypt (data, sendQuery = false) {
  const route = $router.history?.current
  const ouq = { ...route.query }
  delete ouq.sc // 用这个好像才能keys=0
  console.log('encrypt', data, $router, route, ouq, Object.keys(ouq).length)
  let str = ''
  try {
    // const path = window.location.href.split('/#/')?.[1]
    // const pathList = path.split('?')

    str = JSON.stringify({
      ...data,
      i: random(),
      // ou: pathList?.[0] || '',//originUrl
      ou: route?.path?.slice(1), // originUrl,最好拿path，name不一定写的对
      // ouq: sendQuery ? (pathList?.[1] || '') : undefined,//originUrlQuery ,默认不传，否则多次调接口会嵌套很多旧数据,旧方法不去掉?会被截断，所以参数的字符串单独截取出来
      ouq: sendQuery ? (Object.keys(ouq).length ? ouq : undefined) : undefined// 去除上一次调用的sc
    })
  } catch (error) {
    console.error('encrypt JSON.stringify错误', error)
  }

  // return randomCoding() + btoa(str)
  // const result = btoa(str)
  const result = str
  console.log('encrypt result', result)
  return result
}

export function decrypt (str = '') {
  // const newStr = str.slice(1)
  const newStr = str
  let result = ''
  try {
    // const a = atob(newStr)
    const a = str
    result = JSON.parse(a)
  } catch (error) {
    console.error('decrypt atob错误', error, str)
  }
  return result
}
